<template>
  <div class="mobile-month-select">
    <!-- 触发区：纯文字、无背景色（和其它查询条件同一套观感），显示的是「月份」 -->
    <span class="text" :class="{placeholder: !monthText}" @click="toShowDrawer">{{ monthText || placeholder }}</span>
    <mobile-drawer v-model="showDrawer" :title="title" @confirm="confirm">
      <div class="month-drawer">
        <div class="range-row">
          <span class="range-label">{{ rowLabel }}</span>
          <el-date-picker v-model="tempMonth" type="month" value-format="YYYY-MM" placeholder="请选择月份"/>
        </div>
      </div>
    </mobile-drawer>
  </div>
</template>

<script>

import MobileDrawer from "@/components/qywx/data/MobileDrawer.vue";

export default {
  emits: ["update:modelValue", "change"],
  props: {
    // yyyy-MM
    modelValue: {default: ""},
    placeholder: {default: "选择月份"},
    // 抽屉里那一行左边的字段说明，不传就用 placeholder（条件名一般就是字段名）
    label: {default: ""},
    title: {default: "选择月份"},
  },
  name: "MobileMonthSelect",
  components: {
    MobileDrawer
  },
  data() {
    return {
      showDrawer: false,
      tempMonth: "",
    };
  },
  computed: {
    rowLabel() {
      return this.label || this.placeholder;
    },
    /** 仓位上显示「10月」；不是今年的才带上年份 */
    monthText() {
      if (!this.modelValue) {
        return "";
      }
      const parts = String(this.modelValue).split("-");
      if (parts.length !== 2) {
        return this.modelValue;
      }
      const year = Number(parts[0]);
      const month = Number(parts[1]);
      const nowYear = new Date().getFullYear();
      return year === nowYear ? month + "月" : year + "年" + month + "月";
    }
  },
  methods: {
    toShowDrawer() {
      this.tempMonth = this.modelValue;
      this.showDrawer = true;
    },
    confirm() {
      if (this.tempMonth === this.modelValue) {
        return;
      }
      this.$emit("update:modelValue", this.tempMonth);
      this.$emit("change", this.tempMonth);
    }
  }
};
</script>

<style lang="scss" scoped>
.mobile-month-select{
  .text{
    font-size: 12px;
    color: var(--yq-font-color-base);
    white-space: nowrap;
    &.placeholder{
      color: var(--yq-font-color-desc);
    }
  }
}
.month-drawer{
  height: 100%;
  box-sizing: border-box;
  padding: 0 10px;
  .range-row{
    display: flex;
    align-items: center;
    min-height: 60px;
    border-bottom: 1px solid var(--yq-border-color);
    .range-label{
      flex: none;
      width: 110px;
      color: var(--yq-font-color-desc);
    }
    :deep(.el-date-editor){
      flex: 1;
      min-width: 0;
      box-shadow: none;
      padding: 0;
      .el-input__wrapper{
        box-shadow: none;
        padding: 0;
      }
      .el-input__inner{
        text-align: right;
        font-size: inherit;
      }
      // 全局 assets/css/el-input.scss 给 el-input 前缀统一补了个 ":"，这里一并干掉
      .el-input__prefix,
      .el-input__prefix-inner{
        display: none;
      }
    }
  }
}
</style>
